export default __webpack_public_path__ + "static/media/meny_logo.467bd0c2.webp";